import React from 'react';
import { Link } from '@digital-pulse/react';
import { getAdobeFlowName, getLobData } from '@/lib/utils/utils';
import { clickAnalytics, tags } from '@/lib/utils/analytics';

const CustomerCare = ({ pageTag = tags.enterYourInformationPage }) => {
  const { customerCareNumber } = getLobData();
  const handleCustomerCare = () => {
    const data = {
      payload: {
        link_name: `${tags.custom}:${tags.account}:${getAdobeFlowName()}:${pageTag}:${tags.call}`
      }
    };
    clickAnalytics(data);
    window.open(`tel:${customerCareNumber}`);
  };
  const handle711 = () => {
    const data = {
      payload: {
        link_name: `${tags.custom}:${tags.account}:${getAdobeFlowName()}:${pageTag}:${tags.tty}`
      }
    };
    clickAnalytics(data);
    window.open(`tel:711`);
  };
  return (
    <>
      <Link href="javascript:;" onClick={() => handleCustomerCare()}>
        {customerCareNumber}
      </Link>{' '}
      (TTY:
      <Link href="javascript:;" onClick={() => handle711()}>
        711
      </Link>
      )
    </>
  );
};

export default CustomerCare;
